import { z } from 'zod'

export const createKolsResponseSchema = z.object({
  uuid: z.string().uuid(),
})

export type CreateKolsResponse = z.infer<typeof createKolsResponseSchema>

export interface KolsUnlockStatusRequest {
  kol_uuids: string[]
}
export const kolsUnlockStatusResponseSchema = z.object({
  data: z
    .object({
      kol_uuid: z.string().uuid(),
      is_lock: z.boolean(),
    })
    .array(),
})
export type KolsUnlockStatusResponse = z.infer<
  typeof kolsUnlockStatusResponseSchema
>
